<template>
<div style="background:#fcfcfd">
<div class="container">
<div style="padding-top:20px"><span style="cursor:pointer" @click="gotoHome()">HOME</span> - SERVICE</div>
    <div class="row" style="padding:30px 0px;padding-top:15px">
        <div class="col-md-3">
            <left></left>
        </div>
        <div class="col-md-9" style="color:#333;font-size:15px;line-height:25px;">
           
            <p style="text-align:center;margin-bottom:30px">
                <img src="/static/images/service.jpeg" style="width:100%;box-shadow:0px 0px 10px #aaa"/>
            </p>
            <p>
                {{$t('service_title_1')}}            </p>
            <p>
                {{$t('service_title_2')}}       
            </p>
            <div><li>{{$t('service_q_1')}}       </li></div>
            <p>{{$t('service_a_1')}}  </p>

            <div><li>{{$t('service_q_2')}}       </li></div>
            <p>{{$t('service_a_2')}}  </p>

            <div><li>{{$t('service_q_3')}}       </li></div>
            <p>{{$t('service_a_3')}}  </p>

            <div><li>{{$t('service_q_4')}}       </li></div>
            <p>{{$t('service_a_4')}}  </p>

            <div><li>{{$t('service_q_5')}}       </li></div>
            <p>{{$t('service_a_5')}}  </p>


            
        </div>
    </div>
</div>
</div>
</template>

<script>
import left from './left';

export default {
    created(){
    
    },
    mounted(){
        
    },
    components: {
        left
    },
    data(){
        return{
           
        }
    },
    methods:{
        gotoHome(){
            this.$router.push('/');
        },
    }
};
</script>

<style>
.navbar-brand-img{
    width: 150px;
    height:auto;
}
</style>



// WEBPACK FOOTER //
// service.vue?69954065